var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTrash = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.5549 1.2002C6.2224 1.2002 5.9224 1.4077 5.8049 1.7202L5.3999 2.8002H2.9999C2.6674 2.8002 2.3999 3.0677 2.3999 3.4002C2.3999 3.7327 2.6674 4.0002 2.9999 4.0002H12.9999C13.3324 4.0002 13.5999 3.7327 13.5999 3.4002C13.5999 3.0677 13.3324 2.8002 12.9999 2.8002H10.5999L10.1949 1.7202C10.0774 1.4077 9.7799 1.2002 9.4449 1.2002H6.5549ZM3.1174 5.2002L3.6899 12.9177C3.7524 13.7527 4.4474 14.4002 5.2849 14.4002H10.7124C11.5499 14.4002 12.2449 13.7527 12.3074 12.9177L12.8799 5.2002H11.6774L11.1124 12.8302C11.0974 13.0402 10.9224 13.2002 10.7124 13.2002H5.2849C5.0749 13.2002 4.9024 13.0377 4.8849 12.8302L4.3224 5.2002H3.1174ZM9.6949 7.1027C9.4599 6.8677 9.0799 6.8677 8.8474 7.1027L7.9999 7.9502L7.1524 7.1027C6.9174 6.8677 6.5374 6.8677 6.3049 7.1027C6.0724 7.3377 6.0699 7.7177 6.3049 7.9502L7.1524 8.7977L6.3049 9.6452C6.0699 9.88019 6.0699 10.2602 6.3049 10.4927C6.5399 10.7252 6.9199 10.7277 7.1524 10.4927L7.9999 9.6452L8.8474 10.4927C9.0824 10.7277 9.4624 10.7277 9.6949 10.4927C9.9274 10.2577 9.9299 9.8777 9.6949 9.6452L8.8474 8.7977L9.6949 7.9502C9.9299 7.7152 9.9299 7.3352 9.6949 7.1027Z",
  fill: "#E03131"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTrash);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "003d039d162d44142135e96250806734.svg";